import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import CustomButton from '../../../../../Common/CustomButton/CustomButton';
import CustomButtonSS from '../../../../../Common/CustomButton/CustomButtonSS';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import './DmsBucketList.css';
import DrilldownTable from '../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTable';
import CommonToggleSwitch from '../../../../../Common/CommonToggleSwitch/CommonToggleSwitch';
import Popup from '../../../../../Common/Popup/Popup';

const DmsBucketList = (props) => {
    const { bucketList, searchStr, onEdit, onEnableDisable, onDelete, themeSelected, loading } = props;
    const [filteredList, setFilteredList] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedBucket, setSelectedBucket] = useState(null);
    const [currentDeleteIndex, setCurrentDeleteIndex] = useState('NA');
    const dispatch = useDispatch();
    useEffect(() => {
        if (searchStr) {
            const filtered = bucketList.filter(bucket =>
                bucket.WarehouseName?.toLowerCase().includes(searchStr.toLowerCase()) ||
                bucket.StartDate?.toLowerCase().includes(searchStr.toLowerCase()) ||
                bucket.EndDate?.toLowerCase().includes(searchStr.toLowerCase())
            );
            setFilteredList(filtered);
        } else {
            setFilteredList(bucketList);
        }
        // Reset delete index when list changes
        setCurrentDeleteIndex('NA');
    }, [bucketList, searchStr]);
    
    const dmsBucketTitleDD = [
        { id: 'Id', name: 'S.No' },
        { id: 'WarehouseName', name: 'Warehouse Name' },
        { id: 'StartDate', name: 'Start Date' },
        { id: 'EndDate', name: 'End Date' },
        { id: 'StartTime', name: 'Start Time' },
        { id: 'EndTime', name: 'End Time' },
        { id: 'CreatedOn', name: 'Created On' },
        { id: 'Status', name: 'Status' },
        { id: 'actions', name: 'Actions' },
    ];

    const getStatusValue = (status) => {
        // Handle Buffer format: {type: "Buffer", data: [1]}
        if (status?.data && Array.isArray(status.data)) {
            return status.data[0] === 1;
        }
        // Handle boolean format
        return Boolean(status);
    };

    const actionsButton = (ele, index) => {
        return (
            <div className='m-0 p-0 d-flex justify-content-center align-items-center gap-2'>
                <CustomButton
                    title={'Edit'}
                    className={'addButton'}
                    isLoading={false}
                    onClick={() => onEdit(ele)}
                    disabled={false}
                />
                <CustomButtonSS
                    disabled={false}
                    isLoading={currentDeleteIndex !== 'NA' && currentDeleteIndex === index}
                    className={`no-border no-bg`}
                    onClick={() => handleDeleteClick(ele, index)}
                    isIcon={true}
                    iconClass={"fa-regular fa-trash-can fa-lg"}
                />
            </div>
        );
    };

    const handleDeleteClick = (bucket, index) => {
        setSelectedBucket(bucket);
        setCurrentDeleteIndex(index);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = () => {
        if (selectedBucket) {
            onDelete(selectedBucket);
        }
        setShowDeleteModal(false);
    };

    const handleDeleteCancel = () => {
        setShowDeleteModal(false);
        setSelectedBucket(null);
        setCurrentDeleteIndex('NA');
    };

    const showDeleteConfirmation = () => {
        const popupObj = {
            id: 'showDeleteBucketConfirmation',
            modalLabel: 'showDeleteBucketConfirmation',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: 'Delete DMS Bucket',
            bodyText: `${AppConstant.commonStrings.areYouSure} delete this DMS Bucket?`,
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.commonStrings.yes
                },
                btn2: {
                    show: true,
                    text: AppConstant.commonStrings.no
                }
            },
        };

        return (
            <Popup
                {...popupObj}
                popupBtnHandler={(text) => {
                    if (text === AppConstant.commonStrings.yes) {
                        handleDeleteConfirm();
                    } else {
                        handleDeleteCancel();
                    }
                }}
                closepopup={handleDeleteCancel}
                themeSelected={themeSelected}
                showModal={showDeleteModal}
            />
        );
    };

    const getToggleSwitch = (row, index) => {
        const status = getStatusValue(row.Status);

        return (
            <div className='d-flex justify-content-center align-items-center py-1'>
                <CommonToggleSwitch
                    value={status}
                    onChangeValue={() => handleToggleChange(row, index)}
                    allowPermissionD={true}
                />
            </div>
        );
    };

    const handleToggleChange = (row, index) => {
        // Optimistically update the UI
        const updatedList = filteredList.map((item, idx) => {
            if (idx === index) {
                const currentStatus = getStatusValue(item.Status);
                
                // Create a new object with toggled status
                if (item.Status?.data && Array.isArray(item.Status.data)) {
                    return {
                        ...item,
                        Status: {
                            type: item.Status.type,
                            data: [currentStatus ? 0 : 1]
                        }
                    };
                } else {
                    return {
                        ...item,
                        Status: !currentStatus
                    };
                }
            }
            return item;
        });
        
        setFilteredList(updatedList);
        
        // Call the parent handler to update the backend
        onEnableDisable(row);
    };


    const formatListData = (data) => {
        return data && data.map((el, index) => {
            return {
                id: el.Id,
                0: (index + 1),
                1: el.WarehouseName || '-',
                2: el.StartDate ? moment(el.StartDate).format('MM/DD/YYYY') : '-',
                3: el.EndDate ? moment(el.EndDate).format('MM/DD/YYYY') : '-',
                4: el.StartTime ? moment(el.StartTime, "HH:mm").format("HH:mm") : '-',
                5: el.EndTime ? moment(el.EndTime, "HH:mm").format("HH:mm") : '-',
                6: el.CreatedOn || '-',
                7: getToggleSwitch(el, index),
                8: actionsButton(el, index),
            };
        });
    };

    return (
        <>
            <DrilldownTable
                themeSelected={themeSelected}
                bodyData={filteredList && formatListData(filteredList)}
                titleData={dmsBucketTitleDD}
                showCollapse={false}
                showInput={false}
                showSort={false}
                drillDownReport={filteredList}
                initiateDrillDownReport={loading}
                loaderArray={9}
                subRoot={{ pathName: 'dmsBucketManagement' }}
                showUTCTime={false}
            />
            {showDeleteConfirmation()}
        </>
    );
};

export default DmsBucketList;